module.exports = __webpack_public_path__ + "static/media/facebook_sm.a831a115424a16dc635a6093ee67c7ee.svg";